import React from 'react'
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import { List, ListItemButton, ListItemText } from '@mui/material';

function ParentLabour({labour, handleParent}) {
  return (
    <List >
      {labour.map(item => (
        <ListItemButton  sx={{height: '26px'}}key={item.id} onClick={()=> {handleParent(item.id, item.label)}}>
          <ListItemText primary={item.label} />
          {item.children && <ChevronRightOutlinedIcon />}
        </ListItemButton>
      ))}
    </List>
  )
}

export default ParentLabour